import { render, staticRenderFns } from "./StationsView.vue?vue&type=template&id=645ed164&scoped=true&"
import script from "./StationsView.vue?vue&type=script&lang=js&"
export * from "./StationsView.vue?vue&type=script&lang=js&"
import style0 from "./StationsView.vue?vue&type=style&index=0&id=645ed164&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "645ed164",
  null
  
)

/* custom blocks */
import block0 from "./StationsView.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports